<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">상담관리</span>
            <span class="txt">
                기존 회원님 또는 신규회원, 방문회원님 등 다양한 회원님의 상담내역을 기록할 수 있습니다. 기존 회원님의
                상담내역을 등록하시는 경우,
                <br />
                <span class="blue">회원 > 회원관리 > 회원선택 > 상담내역</span>
                메뉴와 연동되어 상담내역을 관리·추적 할 수 있습니다.
            </span>
        </div>
        <loading-spinner v-if="editFieldLoading"></loading-spinner>
        <div v-else class="com-table-wrap">
            <div class="com-card-input half-type">
                <div class="left-box">
                    <div class="line">
                        <span class="tit">
                            회원구분
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <div class="com-radio">
                                <input
                                    id="radio-1-1"
                                    v-model="editField.customerYn"
                                    :value="true"
                                    checked
                                    name="radio-1"
                                    type="radio"
                                />
                                <label for="radio-1-1">회원</label>
                            </div>
                            <div class="com-radio">
                                <input
                                    id="radio-1-2"
                                    v-model="editField.customerYn"
                                    :value="false"
                                    name="radio-1"
                                    type="radio"
                                />
                                <label for="radio-1-2">비회원</label>
                            </div>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">
                            이름
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <input v-model="editField.customerNme" class="w220" type="text" />
                            <button class="com-btn" @click="onClickSearchCustomer">검색</button>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">연락처</span>
                        <div class="input-cnt">
                            <div class="com-tel select-type">
                                <input v-model="telFirst" maxlength="3" type="text" />
                                <input v-model="telSecnd" maxlength="4" type="text" />
                                <input v-model="telThird" maxlength="4" type="text" />
                            </div>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">
                            상담자
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <select-form
                                :select-data="['선택', ...centerStaffList]"
                                :select-value="['', ...centerStaffValueList]"
                                :selected-value="editField.centerStaffId"
                                class="w220"
                                @update:set="(val) => (editField.centerStaffId = val)"
                            ></select-form>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">
                            상담일자
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <single-calendar
                                :date="editField.consultedAt"
                                class="w220"
                                @update="(val) => (editField.consultedAt = val)"
                            ></single-calendar>
                        </div>
                    </div>
                </div>
                <div class="right-box">
                    <div class="line">
                        <span class="tit">
                            상담유형
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <select-form
                                :select-data="['선택', ...consultType]"
                                :select-value="['', ...consultTypeValue]"
                                :selected-value="editField.consultTypeId"
                                class="w220"
                                @update:set="onChangeConsultType"
                            ></select-form>
                            <button class="com-setting-btn" @click="adviceSettingPop = true"></button>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">상담경로</span>
                        <div class="input-cnt flex-col">
                            <div class="com-radio">
                                <input
                                    id="radio-2-1"
                                    v-model="editField.consultPath"
                                    name="radio-2"
                                    type="radio"
                                    value="T"
                                />
                                <label for="radio-1-1">전화</label>
                            </div>
                            <div class="com-radio">
                                <input
                                    id="radio-2-2"
                                    v-model="editField.consultPath"
                                    name="radio-2"
                                    type="radio"
                                    value="V"
                                />
                                <label for="radio-2-2">방문</label>
                            </div>
                            <div class="com-radio">
                                <input
                                    id="radio-2-3"
                                    v-model="editField.consultPath"
                                    name="radio-2"
                                    type="radio"
                                    value="E"
                                />
                                <label for="radio-2-3">기타</label>
                            </div>
                            <input
                                v-if="editField.consultPath === 'E'"
                                v-model="editField.consultPathEtc"
                                class="w200"
                                placeholder="상담 경로를 입력해주세요"
                                type="text"
                            />
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">유입경로</span>
                        <div class="input-cnt">
                            <select-form
                                :select-data="['유입경로', ...consultFunnel]"
                                :select-value="[0, ...consultFunnelValue]"
                                :selected-value="editField.centerConsultFunnelId"
                                class="w220"
                                @update:set="(val) => (editField.centerConsultFunnelId = val)"
                            ></select-form>
                            <button
                                class="com-setting-btn"
                                @click="
                                    checkAllowedClick('MB', 4, () => {
                                        funnelSettingPop = true;
                                    })
                                "
                            ></button>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">메모</span>
                        <div class="input-cnt">
                            <ckeditor v-model="editField.memo" :config="editorConfig" :editor="editor"></ckeditor>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="bottom-btn">
            <button class="com-btn blue" @click="onClickCreateConsult">등록</button>
        </div>

        <div class="com-search-content">
            <div class="line">
                <div class="com-calendar-wrap">
                    <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                    <div class="com-dash"><span class="dash">~</span></div>
                    <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                </div>
                <select-form
                    :select-data="['선택', ...periodTypeList]"
                    :select-value="['', ...periodTypeValueList]"
                    :selected-value="searchPeriod"
                    @update:set="(val) => (searchPeriod = val)"
                ></select-form>
            </div>
            <div class="line">
                <select-form
                    :select-data="['상담자', ...centerStaffList]"
                    :select-value="['', ...centerStaffValueList]"
                    @update:set="(val) => (centerStaffId = val)"
                ></select-form>
                <select-form
                    :select-data="['상담유형', ...consultType]"
                    :select-value="['', ...consultTypeValue]"
                    @update:set="(val) => (consultTypeId = val)"
                ></select-form>
                <button class="com-search-reset" @click="resetSearchParams"></button>
            </div>
        </div>

        <div class="com-table-content">
            <loading-spinner v-if="consultListIsLoading"></loading-spinner>
            <table v-else class="com-table">
                <colgroup>
                    <col style="width: 160px" />
                    <col style="width: 110px" />
                    <col style="width: 140px" />
                    <col style="width: 140px" />
                    <col style="width: 110px" />
                    <col style="width: 110px" />
                    <col style="width: 425px" />
                    <col style="width: 110px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>상담일자</th>
                        <th>회원명</th>
                        <th>상담자</th>
                        <th>상담유형</th>
                        <th>상담경로</th>
                        <th>유입경로</th>
                        <th>상담내용</th>
                        <th>수정 / 삭제</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(c, index) in consultListInfo" :key="index">
                        <td>{{ c.c_consult_dt | timestampFilter }}</td>
                        <td>
                            <span>{{ c.c_cust_nm }}</span>
                        </td>
                        <td>{{ c.c_center_staff_nm }}</td>
                        <td>{{ c.c_consult_type_nm }}</td>
                        <td>{{ convertConsultPath(c.c_consult_path, c.c_consult_path_etc) }}</td>
                        <td>{{ c.c_info_path }}</td>

                        <td v-if="c.c_memo.includes('<img')">
                            <span>상담내용에 사진이 포함되어 있습니다.</span>
                        </td>
                        <td v-else>
                            <div
                                style="
                                    line-height: 27px;
                                    width: 425px;
                                    height: 100%;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                "
                                v-html="c.c_memo.replaceAll('&nbsp;', '')"
                            ></div>
                        </td>
                        <td style="text-align: center">
                            <button
                                style="
                                    width: 30px;
                                    height: 30px;
                                    background-image: url('/img/icons/table_modify_btn.png');
                                    background-size: 30px;
                                    margin-right: 10px;
                                "
                                @click="onClickModifyConsult(c.c_center_id, c.c_center_consult_id)"
                            >
                                <span class="blind">수정하기</span>
                            </button>
                            <button
                                style="
                                    width: 30px;
                                    height: 30px;
                                    background-image: url('/img/icons/ic_ad_del.png');
                                    background-size: 30px;
                                "
                                @click="onClickDeleteConsult(c.c_center_id, c.c_center_consult_id)"
                            >
                                <span class="blind">삭제하기</span>
                            </button>
                        </td>
                    </tr>
                    <tr v-if="consultListInfo.length === 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="sort-bottom-area">
            <select-form
                :select-data="[...sortTypeList]"
                :select-value="[...sortTypeValueList]"
                class="float-right"
                @update:set="changeLimit"
            ></select-form>
        </div>
        <b-pagination
            v-model="consultPagingInfo.page"
            :per-page="consultPagingInfo.limit"
            :total-rows="consultPagingInfo.totalItems"
            align="center"
            aria-controls="my-table"
            first-class="first"
            last-class="last"
            next-class="next"
            prev-class="prev"
            @change="handlerPagenation($event, 'consult')"
        ></b-pagination>

        <!-- 상담내용 수정 레이어 팝업 -->
        <div v-show="advicePop" class="layer-pop square">
            <div class="view-content max-width: 90vw !important">
                <!-- 팝업 width 정적 사이징 해두면, 해상도 낮은 모니터에서 팝업 가로 짤리므로, 수정 -->
                <button class="close" @click="onClickCancleConsultDetail"><span class="blind">팝업 닫기</span></button>
                <loading-spinner v-if="detailConsultLoading"></loading-spinner>
                <div v-else class="scroll-area com-scroll-y">
                    <span class="title">상담내용 수정</span>
                    <div class="com-form-box">
                        <div class="line">
                            <div class="sub">
                                <span class="tit">이름</span>
                                <input v-model="detailEditField.customerNme" class="w220" readonly type="text" />
                            </div>
                            <div class="sub">
                                <span class="tit">
                                    상담자
                                    <span class="imp">*</span>
                                </span>
                                <select-form
                                    :select-data="['상담자', ...centerStaffList]"
                                    :select-value="['', ...centerStaffValueList]"
                                    :selected-value="detailEditField.centerStaffId"
                                    @update:set="(val) => (detailEditField.centerStaffId = val)"
                                ></select-form>
                            </div>
                            <div class="sub">
                                <span class="tit">상담일자</span>
                                <single-calendar
                                    :date="detailEditField.consultedAt"
                                    class="w220"
                                    @update="(val) => (detailEditField.consultedAt = val)"
                                ></single-calendar>
                            </div>
                            <div class="sub">
                                <span class="tit">
                                    상담유형
                                    <span class="imp">*</span>
                                </span>
                                <select-form
                                    :select-data="['상담유형', ...consultType]"
                                    :select-value="['', ...consultTypeValue]"
                                    :selected-value="detailEditField.consultTypeId"
                                    @update:set="onChangeDetailConsultType"
                                ></select-form>
                                <button class="com-setting-btn" @click="adviceSettingPop = true">
                                    <span class="blind">설정</span>
                                </button>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">상담경로</span>
                            <div class="flex">
                                <div class="com-radio">
                                    <input
                                        id="radio-f1-1"
                                        v-model="detailEditField.consultPath"
                                        name="radio-f1"
                                        type="radio"
                                        value="T"
                                    />
                                    <label for="radio-f1-1">전화</label>
                                </div>
                                <div class="com-radio">
                                    <input
                                        id="radio-f1-2"
                                        v-model="detailEditField.consultPath"
                                        name="radio-f1"
                                        type="radio"
                                        value="V"
                                    />
                                    <label for="radio-f1-2">방문</label>
                                </div>
                                <div class="com-radio">
                                    <input
                                        id="radio-f1-3"
                                        v-model="detailEditField.consultPath"
                                        name="radio-f1"
                                        type="radio"
                                        value="E"
                                    />
                                    <label for="radio-f1-3">기타</label>
                                </div>
                                <input
                                    v-if="detailEditField.consultPath === 'E'"
                                    v-model="detailEditField.consultPathEtc"
                                    class="w200"
                                    placeholder="상담 경로를 입력해주세요"
                                    type="text"
                                />
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">유입경로</span>
                            <select-form
                                :select-data="['유입경로', ...consultFunnel]"
                                :select-value="[0, ...consultFunnelValue]"
                                :selected-value="detailEditField.centerConsultFunnelId"
                                class="w220"
                                @update:set="(val) => (detailEditField.centerConsultFunnelId = val)"
                            ></select-form>
                            <button
                                class="com-setting-btn"
                                @click="
                                    checkAllowedClick('MB', 4, () => {
                                        funnelSettingPop = true;
                                    })
                                "
                            ></button>
                        </div>
                        <div class="line">
                            <span class="tit">메모</span>
                            <div class="input-cnt">
                                <ckeditor
                                    v-model="detailEditField.memo"
                                    :config="editorConfig2"
                                    :editor="editor2"
                                ></ckeditor>
                            </div>
                        </div>
                    </div>

                    <div class="bottom-btn">
                        <button class="com-btn" @click="onClickCancleConsultDetail">취소</button>
                        <button class="com-btn blue" @click="onClickSaveConsultDetail">수정</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 회원 검색 팝업 -->
        <div v-show="userPop" class="layer-pop square-type">
            <div class="view-content">
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">회원 검색 결과</span>
                    <div class="top-search-area">
                        <div class="right">
                            <input
                                ref="refCustomerName"
                                v-model="searchCustomerStr"
                                class="w220"
                                placeholder="회원명"
                                type="text"
                                v-on:keyup.enter="onSearchCustomer"
                            />
                            <button class="com-btn" @click="onSearchCustomer">검색</button>
                        </div>
                    </div>
                    <table class="com-table">
                        <colgroup>
                            <col style="width: 70px" />
                            <col style="width: 120px" />
                            <col style="width: 160px" />
                            <col style="width: 160px" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th></th>
                                <th>회원명</th>
                                <th>연락처</th>
                                <th>생년월일</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(c, index) in searchCustomerList" :key="index">
                                <td>
                                    <div class="com-radio">
                                        <input
                                            :id="`radio-pop-${index + 1}`"
                                            v-model="pickedCustomerId"
                                            :value="c.center_cust_id"
                                            name="radio-pop"
                                            type="radio"
                                        />
                                        <label :for="`radio-pop-${index + 1}`"></label>
                                    </div>
                                </td>
                                <td>{{ c.namee }}</td>
                                <td>{{ c.phone | phoneNumberFilter }}</td>
                                <td>{{ c.birthday | dateFormatFilter }}</td>
                            </tr>
                            <tr v-if="searchCustomerList.length === 0">
                                <td colspan="100">등록된 내용이 없습니다.</td>
                            </tr>
                        </tbody>
                    </table>
                    <b-pagination
                        v-model="customerPagingInfo.page"
                        :per-page="customerPagingInfo.limit"
                        :total-rows="customerPagingInfo.totalItems"
                        align="center"
                        aria-controls="my-table"
                        first-class="first"
                        last-class="last"
                        next-class="next"
                        prev-class="prev"
                        @change="handlerPagenation($event, 'customer')"
                    ></b-pagination>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="onClickCancleSearchPop">취소</button>
                        <button class="com-btn blue" @click="onClickPickCustomer">선택</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 상담유형 설정 팝업 -->
        <div v-show="adviceSettingPop" class="layer-pop square-type">
            <div class="view-content">
                <button class="close" @click="onClickCancleConsultType"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">상담유형 설정</span>
                    <p class="sub-txt">상담유형의 종류를 추가, 수정 및 삭제 할 수 있습니다.</p>
                    <loading-spinner v-if="consultPopupLoading"></loading-spinner>
                    <div v-else class="del-box">
                        <div class="input-cnt flex-col">
                            <div v-for="(c, index) in consultTypeList.types" class="line">
                                <input :key="index" ref="consultTypeArray" v-model="c.consultTypeName" type="text" />
                                <button class="com-btn" @click="onClickDeleteConsultType(c.centerConsultTypeId, index)">
                                    삭제
                                </button>
                            </div>
                        </div>
                        <div class="add-btn-cnt">
                            <div class="line">
                                <button class="com-btn" @click="onClickAddConsultType">+추가</button>
                            </div>
                        </div>
                    </div>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="onClickCancleConsultType">취소</button>
                        <button class="com-btn blue" @click="onClickSaveConsultType">저장</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 유입경로 설정 팝업 -->
        <div v-show="funnelSettingPop" class="layer-pop square-type">
            <div class="view-content">
                <button class="close" @click="onClickCancelConsultFunnel"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">유입경로 설정</span>
                    <p class="sub-txt">유입경로의 종류를 추가, 수정 및 삭제 할 수 있습니다.</p>
                    <loading-spinner v-if="consultPopupLoading"></loading-spinner>
                    <div v-else class="del-box">
                        <div class="input-cnt flex-col">
                            <div v-for="(c, index) in consultFunnelList.types" :key="index" class="line">
                                <input
                                    :key="index"
                                    ref="consultFunnelArray"
                                    v-model="c.consultFunnelName"
                                    type="text"
                                />
                                <button
                                    class="com-btn"
                                    @click="onClickDeleteConsultFunnel(c.centerConsultFunnelId, index)"
                                >
                                    삭제
                                </button>
                            </div>
                        </div>
                        <div class="add-btn-cnt">
                            <div class="line">
                                <button class="com-btn" @click="onClickAddConsultFunnel">+추가</button>
                            </div>
                        </div>
                    </div>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="onClickCancelConsultFunnel">취소</button>
                        <button class="com-btn blue" @click="onClickSaveConsultFunnel">저장</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '@/components/LoadingSpinner';
import { validateTelNo } from '@/assets/js/validation';
import moment from 'moment';
import EventBus from '../../../assets/js/eventBus';
import ClassicEditor from '@/assets/js/ckeditor/ckeditor';
import SimpleUpload from '@/assets/js/ckeditor/simpleUpload';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import ClassicEditor2 from '@/assets/js/ckeditor/ckeditor';
import SimpleUpload2 from '@/assets/js/ckeditor/simpleUpload';
import { pagingInfo } from '@/assets/js/common';

export default {
    name: 'memberConsultDetail',
    components: { LoadingSpinner },
    mixins: [MixinAllowedMenu],
    props: {},
    watch: {
        'editField.centerConsultFunnelId': function () {
            console.log(this.editField.centerConsultFunnelId);
            console.log(this.detailEditField.centerConsultFunnelId);
        },
        'detailEditField.centerConsultFunnelId': function () {
            console.log(this.editField.centerConsultFunnelId);
            console.log(this.detailEditField.centerConsultFunnelId);
        },
        centerStaffId(newValue) {
            // 상담자
            this.fetchConsultList();
        },
        consultTypeId(newValue) {
            // 상담유형
            this.fetchConsultList();
        },
        searchPeriod(newValue) {
            // 검색 기간 설정 변수
            this.searchPeriod = newValue;

            if (newValue === 'today') {
                // 오늘
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                // 어제
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'thisMonth') {
                // 이번 달
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                // 지난 달
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === '3M') {
                // 3개월
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '6M') {
                // 6개월
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '12M') {
                // 12개월
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '') {
                this.initStartDate();
                this.initEndDate();
            }
            this.fetchConsultList();
        },
        startDate(newValue) {
            // 검색 시작일
            this.startDate = newValue;
        },
        endDate(newValue) {
            // 검색 종료일
            this.endDate = newValue;
        },
    },
    computed: {
        fullTelNo() {
            return `${this.telFirst}${this.telSecnd}${this.telThird}`;
        },
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    mounted() {
        this.centerId = this.$route.params.id;
        this.customerId = this.$route.query.customerId;
        this.consultId = this.$route.query.consultId;
        this.init();
    },
    data() {
        return {
            advicePop: false,
            adviceSettingPop: false,
            userPop: false,
            editFieldLoading: false,
            isLoading: false,
            consultPopupLoading: false,
            detailConsultLoading: false,
            centerId: '',
            customerId: '',
            consultId: '',
            editField: {
                customerYn: true,
                customerNme: '',
                telNo: ['', '', ''],
                consultedAt: '',
                consultPath: 'T',
                consultPathEtc: '',
                memo: '',
                consultTypeId: '',
                consultTypeName: '',
                centerStaffId: '',
                centerConsultFunnelId: 0,
            },
            detailEditField: {
                // 상담 내용 수정 editField
                customerYn: true,
                customerNme: '',
                telNo: ['', '', ''],
                consultedAt: '',
                consultPath: 'T',
                consultPathEtc: '',
                memo: '',
                consultTypeId: '',
                consultTypeName: '',
                centerStaffId: '',
                centerConsultFunnelId: 0,
            },
            searchCustomerStr: '', // 회원 검색 키워드
            searchCustomerList: [],
            pickedCustomerId: '', // 선택한 회원의 customerId
            customerInfo: {},
            customerpagingInfo: { ...pagingInfo },

            consultListInfo: [], // 상담목록 가공전
            consultTypeList: {
                types: [],
            },
            consultType: [],
            consultTypeValue: [],
            consultPagingInfo: { ...pagingInfo },

            centerStaffList: [], // centerStaff(상담자) 이름 목록
            centerStaffValueList: [], // centerStaff(상담자) ID 목록

            searchPeriod: '', // 검색 기간 설정
            startDate: '', // 검색 시작일
            endDate: '', // 검색 종료일

            consultTypeId: '', // 상담유형 검색 파라미터
            centerStaffId: '', // 상담자 검색 파라미터

            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],

            periodTypeList: [...this.$periodTypeList],
            periodTypeValueList: [...this.$periodTypeValueList],

            consultDetailInfo: {}, // 상담 내용 상세 가공 전
            detailConsultId: '', // 상담 수정 팝업 consultId

            count: 1,

            editor: ClassicEditor,
            editorConfig: {
                extraPlugins: [SimpleUpload],
                height: '500px',
                language: 'ko',
                simpleUpload: {
                    uploadUrl: '/admin/api/board/file',
                    headers: {
                        'X-CSRF-TOKEN': 'CSRF-Token',
                    },
                },
            },

            editor2: ClassicEditor2,
            editorConfig2: {
                extraPlugins: [SimpleUpload2],
                height: '500px',
                language: 'ko',
                simpleUpload: {
                    uploadUrl: '/admin/api/board/file',
                    headers: {
                        'X-CSRF-TOKEN': 'CSRF-Token',
                    },
                },
            },

            consultListIsLoading: false,
            consultFunnel: [],
            consultFunnelValue: [],
            funnelSettingPop: false,
            consultFunnelList: {
                types: [],
            },
            telFirst: '',
            telSecnd: '',
            telThird: '',
        };
    },
    methods: {
        // 유입경로 유형 삭제 API 호출
        sendDeleteConsultFunnel(consultFunnelId) {
            return api.delete(`/admin/api/center/${this.centerId}/consult-Funnel/${consultFunnelId}`);
        },

        // 유입경로 삭제 버튼 클릭시
        async onClickDeleteConsultFunnel(consultFunnelId, index) {
            if (!confirm('유입경로를 삭제하시겠습니까?')) {
                return false;
            }
            try {
                if (consultFunnelId === undefined) {
                    this.consultFunnelList.types.splice(index, 1);
                } else {
                    this.consultPopupLoading = true;
                    await this.sendDeleteConsultFunnel(consultFunnelId);
                    alert('유입경로 삭제했습니다.');
                    await this.fetchConsultFunnel();
                    this.consultPopupLoading = false;
                }
            } catch (error) {
                this.consultPopupLoading = false;
                alert('유입경로 삭제 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 유입경로 추가 버튼 클릭시
        onClickAddConsultFunnel() {
            this.consultFunnelList.types.push({
                consultFunnelName: '',
            });
        },

        // 상담유형 설정 팝업에서 취소 버튼 클릭시
        async onClickCancelConsultFunnel() {
            this.funnelSettingPop = false;
            await this.fetchConsultFunnel();
        },
        // 상담유형 설정 팝업 수정, 등록 validation
        validateConsultFunnelValues() {
            const msg = '상담유형을 다시 확인하세요.';
            let result = true;
            let resultIndex = '';
            this.$refs.consultTypeArray.some((c, index) => {
                if (c.value.replaceAll(' ', '').length === 0 || c.value.length < 2) {
                    result = false;
                    resultIndex = index;
                    return true;
                }
            });
            return {
                result,
                resultIndex,
                msg,
            };
        },

        // 상담유형 설정 팝업에서 저장 버튼 클릭시
        async onClickSaveConsultFunnel() {
            const validate = this.validateConsultFunnelValues();
            for (const element of this.consultFunnelList.types) {
                if (element.consultFunnelName == '') {
                    alert('유입경로를 입력해주세요');
                    return;
                }
            }
            if (!validate.result) {
                alert(validate.msg);
                this.$nextTick(function () {
                    this.$refs.consultFunnelArray[validate.resultIndex].focus();
                });
                return;
            }

            try {
                this.consultPopupLoading = true;
                await this.sendPostSaveConsultFunnel();
                alert('유입경로를 저장했습니다.');
                await this.fetchConsultFunnel(); // 상담유형 다시 불러오기
                this.consultPopupLoading = false;
            } catch (error) {
                this.consultPopupLoading = false;
                alert('유입경로 저장 중 오류가 발생했습니다.');
                console.log(error);
            }
        },
        // 유입경로 저장 API 호출
        sendPostSaveConsultFunnel() {
            return api.post(`/admin/api/center/${this.centerId}/consult-Funnel`, {
                centerConsultFunnelInput: this.consultFunnelList.types,
            });
        },

        fetchConsultFunnel() {
            this.consultFunnel = [];
            this.consultFunnelValue = [];
            this.consultFunnelList.types = [];
            return api.get(`/admin/api/center/${this.centerId}/consult-funnel`).then((res) => {
                res.data.map((element) => {
                    this.consultFunnel.push(element.c_consult_funnel_nm);
                    this.consultFunnelValue.push(element.c_center_consult_funnel_id);
                    this.consultFunnelList.types.push({
                        consultFunnelName: element.c_consult_funnel_nm,
                        centerConsultFunnelId: element.c_center_consult_funnel_id,
                    });
                });
            });
        },
        // 초기화
        init() {
            this.initStartDate();
            this.initEndDate();
            Promise.allSettled([
                this.fetchConsultType(),
                this.fetchConsultList(),
                this.fetchCenterStaffList(),
                this.fetchConsultFunnel(),
                this.testFunction(this.centerId, this.consultId),
            ]);
            // 상담유형 목록 가져오기
            // 상담목록 가져오기
            // 직원(상담자) 목록 가져오기
            // 검색 시작일 초기화
            // 검색 종료일 초기화
        },

        // 검색 시작일 초기화
        initStartDate() {
            const startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
            this.startDate = startDate;
        },

        // 검색 종료일 초기화
        initEndDate() {
            const endDate = moment().format('YYYY-MM-DD');
            this.endDate = endDate;
        },

        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            this.fetchConsultList();
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
            this.fetchConsultList();
        },

        // 검색 조건 초기화
        resetSearchParams() {
            this.initStartDate(); // 시작일 검색 파라미터
            this.initEndDate(); // 종료일 검색 파라미터
            (this.consultTypeId = ''), // 상담유형 검색 파라미터
                (this.centerStaffId = ''), // 상담자 검색 파라미터
                this.fetchConsultList();
            EventBus.$emit('event:initList', 'init');
        },

        // 상담 유형 가져오기
        async fetchConsultType() {
            try {
                // 상담 유형 관련 변수 초기화
                this.consultTypeList = {
                    types: [],
                };
                this.consultType = [];
                this.consultTypeValue = [];

                const { data } = await this.sendGetConsultType();
                data.forEach((c) => {
                    // select-form 셋팅
                    this.consultType.push(c.c_consult_type_nm);
                    this.consultTypeValue.push(c.c_center_consult_type_id);

                    const temp = {
                        centerConsultTypeId: c.c_center_consult_type_id,
                        consultTypeName: c.c_consult_type_nm,
                    };
                    this.consultTypeList.types.push(temp);
                });
                console.log('===> 상담 유형 목록 조회 : ', data);
            } catch (error) {
                alert('상담 유형을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 상담 유형 목록 조회 API 호출
        sendGetConsultType() {
            return api.get(`/admin/api/center/${this.centerId}/consult-type`);
        },

        // 상담목록 가져오기
        async fetchConsultList() {
            try {
                this.isLoading = true;
                const { data } = await this.sendGetConsult();
                this.consultListInfo = data.items;
                this.setPageParams(data, 'consult');
                console.log('===> 상담 목록 조회 : ', data.items);
                this.isLoading = false;
            } catch (error) {
                alert('상담 목록을 불러오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 상담 목록 조회 API
        sendGetConsult() {
            const { consultTypeId, centerStaffId, startDate, endDate, customerId } = this;
            const searchParams = {
                consultTypeId,
                centerStaffId,
                startDate,
                endDate,
                customerId,
            };

            return api.get(`/admin/api/center/${this.centerId}/consult`, {
                params: {
                    ...this.consultPagingInfo,
                    ...searchParams,
                },
            });
        },

        // 직원(상담자) 목록 가져오기
        async fetchCenterStaffList() {
            try {
                const { data } = await this.sendGetCenterStaffList();
                data.forEach((d) => {
                    this.centerStaffList.push(d.name);
                    this.centerStaffValueList.push(d.centerStaffId);
                });
            } catch (error) {
                alert('직원 목록을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 직원 목록 API 호출
        sendGetCenterStaffList() {
            return api.get(`/admin/api/center/${this.centerId}/staff/teachers/list`);
        },

        // 상담 등록 버튼 클릭시
        async onClickCreateConsult() {
            const validate = this.validateValues();
            if (!validate.result) {
                alert(validate.msg);
                return false;
            }
            try {
                this.editFieldLoading = true;
                const { data } = await this.sendPostCreateConsult();
                alert('상담내역이 등록 되었습니다.');
                await this.fetchConsultList();
                this.initEditField(); // 상담 등록 후 상담 관리 등록 내용 초기화
                this.editFieldLoading = false;
            } catch (error) {
                alert('상담 등록 중 오류가 발생했습니다.');
                console.log(error);
                this.editFieldLoading = false;
            }
        },

        // 상담 관리 내용 초기화
        initEditField() {
            const init = {
                customerYn: true,
                customerNme: '',
                telNo: ['', '', ''],
                consultedAt: '',
                consultPath: 'T',
                memo: '',
                consultTypeId: '',
                consultTypeName: '',
                centerStaffId: '',
                centerConsultFunnelId: 0,
            };
            this.editField = init;
            this.telThird = null;
            this.telFirst = null;
            this.telSecnd = null;
            this.customerId = '';
        },

        // 센터 상담관리 생성 API 호출
        sendPostCreateConsult() {
            const params = this.getCreateParams();
            console.log('params', params);
            return api.post(`/admin/api/center/${this.centerId}/consult`, params);
        },

        // 센터 상담관리 생성 파라미터 가공
        getCreateParams() {
            const { customerId } = this;
            const {
                customerYn,
                customerNme,
                consultedAt,
                consultPath,
                consultPathEtc,
                centerConsultFunnelId,
                memo,
                centerStaffId,
                consultTypeId,
                consultTypeName,
            } = this.editField;
            let telNo;
            if (this.fullTelNo.includes('undefine')) {
                telNo = '';
            } else {
                telNo = this.fullTelNo;
            }

            const params = {
                customerYn,
                customerId,
                customerNme,
                telNo,
                centerStaffId,
                consultedAt,
                consultTypeId,
                consultPathEtc,
                consultTypeName,
                consultPath,
                centerConsultFunnelId,
                memo,
            };

            if (centerStaffId === '') {
                delete params.centerStaffId;
            } else if (customerId === '') {
                delete params.customerId;
            }
            return params;
        },

        // 회원 검색 팝업 취소 버튼 클릭시
        onClickCancleSearchPop() {
            this.userPop = false;
            this.searchCustomerStr = '';
            this.searchCustomerList = [];
        },

        // 회원 검색 팝업 선택 버튼 클릭시
        async onClickPickCustomer() {
            if (this.pickedCustomerId === '') {
                alert('회원을 선택하세요.');
                return;
            }
            await this.fetchCustomerDetail(this.pickedCustomerId); // 선택한 회원 id로 customer 상세 정보 가져옴
            this.customerId = this.pickedCustomerId; // 현재 페이지의 customerId를 넣어줌

            // 회원 검색 관련 변수 초기화
            this.userPop = false;
            this.searchCustomerStr = '';
            this.searchCustomerList = [];
        },

        // 센터 회원 기본 정보 가져오기
        async fetchCustomerDetail(customerId) {
            try {
                const { data } = await this.sendGetCustomerDetail(customerId);
                this.customerInfo = data; // 가져온 그대로 customerInfo에 넣기

                this.editField.customerNme = this.customerInfo.name;
                this.telFirst = this.splitPhoneNumber(this.customerInfo.phone)[0];
                this.telSecnd = this.splitPhoneNumber(this.customerInfo.phone)[1];
                this.telThird = this.splitPhoneNumber(this.customerInfo.phone)[2];

                console.log('===> Success Loading Center Customer Detail : ', data);
            } catch (error) {
                alert('회원 정보를 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },
        async testFunction(centerId, consId) {
            try {
                const { data } = await this.fetchConsultDetail(centerId, consId);
                this.editField = data; // 가져온 그대로 customerInfo에 넣기
                console.log(data);
                // this.editField.customerNme = this.editField.name;
                this.telFirst = this.splitPhoneNumber(this.editField.telNo)[0];
                this.telSecnd = this.splitPhoneNumber(this.editField.telNo)[1];
                this.telThird = this.splitPhoneNumber(this.editField.telNo)[2];

                console.log('===> Success Loading Center Customer Detail : ', data);
            } catch (error) {
                alert('회원 정보를 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },
        // 센터 회원 기본 정보 조회 API 호출
        sendGetCustomerDetail(customerId) {
            return api.get(`/admin/api/center/${this.centerId}/customer/${customerId}`);
        },

        // 회원명으로 회원 검색
        async onSearchCustomer() {
            try {
                const { data } = await this.sendGetCustomer();
                this.setPageParams(data, 'customer');
                this.searchCustomerList = data.items;
            } catch (error) {
                alert('회원 검색 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터 회원 페이징 목록 조회
        sendGetCustomer() {
            return api.get(`/admin/api/center/${this.centerId}/customer`, {
                params: {
                    ...this.customerPagingInfo,
                    searchStr: this.searchCustomerStr,
                },
            });
        },

        // 이름 검색 버튼 클릭시
        onClickSearchCustomer() {
            this.userPop = true;
        },

        // 페이징 Param set
        setPageParams(data, type) {
            if (type === 'customer') {
                this.customerPagingInfo.totalPages = data.meta.totalPages;
                this.customerPagingInfo.page = data.meta.currentPage;
                this.customerPagingInfo.totalItems = data.meta.totalItems;
                this.customerPagingInfo.itemCount = data.meta.itemCount;
            } else if (type === 'consult') {
                this.consultPagingInfo.totalPages = data.meta.totalPages;
                this.consultPagingInfo.page = data.meta.currentPage;
                this.consultPagingInfo.totalItems = data.meta.totalItems;
                this.consultPagingInfo.itemCount = data.meta.itemCount;
            }
        },

        // 상담유형 삭제 버튼 클릭시
        async onClickDeleteConsultType(consultTypeId, index) {
            if (!confirm('상담유형을 삭제하시겠습니까?')) {
                return false;
            }
            try {
                if (consultTypeId === undefined) {
                    this.consultTypeList.types.splice(index, 1);
                } else {
                    this.consultPopupLoading = true;
                    await this.sendDeleteConsultType(consultTypeId);
                    alert('상담유형을 삭제했습니다.');
                    await this.fetchConsultType();
                    this.consultPopupLoading = false;
                }
            } catch (error) {
                alert('상담유형 삭제 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 상담유형 삭제 API 호출
        sendDeleteConsultType(consultTypeId) {
            return api.delete(`/admin/api/center/${this.centerId}/consult-type/${consultTypeId}`);
        },

        // 상담유형 추가 버튼 클릭시
        onClickAddConsultType() {
            this.consultTypeList.types.push({
                consultTypeName: '',
            });
        },

        // 상담유형 설정 팝업에서 취소 버튼 클릭시
        async onClickCancleConsultType() {
            this.adviceSettingPop = false;
            await this.fetchConsultType();
        },

        // 상담유형 설정 팝업에서 저장 버튼 클릭시
        async onClickSaveConsultType() {
            const validate = this.validateConsultTypeValues();
            console.log(validate);
            if (!validate.result) {
                alert(validate.msg);
                this.$nextTick(function () {
                    this.$refs.consultTypeArray[validate.resultIndex].focus();
                });
                return;
            }
            try {
                this.consultPopupLoading = true;
                const { data } = await this.sendPostSaveConsultType();
                alert('상담유형을 저장했습니다.');
                await this.fetchConsultType(); // 상담유형 다시 불러오기
                this.consultPopupLoading = false;
            } catch (error) {
                alert('상담유형 저장 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 상담유형 저장 API 호출
        sendPostSaveConsultType() {
            return api.post(`/admin/api/center/${this.centerId}/consult-type`, {
                ...this.consultTypeList,
            });
        },

        // 상담유형 설정 팝업 수정, 등록 validation
        validateConsultTypeValues() {
            const msg = '상담유형을 다시 확인하세요.';
            let result = true;
            let resultIndex = '';
            this.$refs.consultTypeArray.some((c, index) => {
                if (c.value.replaceAll(' ', '').length === 0 || c.value.length < 2) {
                    result = false;
                    resultIndex = index;
                    return true;
                }
            });
            return {
                result,
                resultIndex,
                msg,
            };
        },

        // 상담관리 등록시 필수값 체크
        validateValues() {
            const telFirst = this.telFirst;
            const telSecnd = this.telSecnd;
            const telThird = this.telThird;
            // 필수값 체크
            let result = false;
            let { customerNme, telNo, consultTypeId, centerStaffId, consultedAt } = this.editField;
            let msg = '';
            telNo = [telFirst, telSecnd, telThird];

            // 이름
            if (customerNme.trim() === '') {
                msg = '이름을 입력하세요.';
                return {
                    result,
                    msg,
                };
            }
            if (customerNme.trim().length < 2) {
                msg = '이름을 다시 입력하세요.';
                return {
                    result,
                    msg,
                };
            }
            if (!this.fullTelNo.includes('undefine')) {
                // 연락처, 필수값 아니나 입력을 했으면 validate
                if (
                    this.fullTelNo.length > 0 &&
                    (!validateTelNo(this.fullTelNo) ||
                        telFirst.length < 2 ||
                        telSecnd.length < 3 ||
                        telThird.length != 4)
                ) {
                    msg = '연락처를 다시 확인하세요.';
                    return {
                        result,
                        msg,
                    };
                }
            }

            if (!consultedAt) {
                msg = '상담일자를 선택하세요.';
                return {
                    result,
                    msg,
                };
            }

            if (!consultTypeId) {
                msg = '상담유형을 선택하세요.';
                return {
                    result,
                    msg,
                };
            }

            if (!centerStaffId) {
                msg = '상담자를 선택하세요.';
                return {
                    result,
                    msg,
                };
            }
            result = true;
            return { result };
        },

        // 상담유형 select-form 변경시
        onChangeConsultType(val) {
            const index = this.consultTypeList.types.findIndex((c) => c.centerConsultTypeId === val); // consultTypeId로 consultTypeName을 찾기 위해 index를 구함
            this.editField.consultTypeName = this.consultType[index];
            this.editField.consultTypeId = val;
        },

        // 상담내용수정 화면 > 상담유형 select-form 변경시
        onChangeDetailConsultType(val) {
            const index = this.consultTypeList.types.findIndex((c) => c.centerConsultTypeId === val); // consultTypeId로 consultTypeName을 찾기 위해 index를 구함
            this.detailEditField.consultTypeName = this.consultType[index];
            this.detailEditField.consultTypeId = val;
        },

        // 상담경로 변환
        convertConsultPath(path, etc) {
            if (path === 'T') {
                return '전화';
            } else if (path === 'V') {
                return '방문';
            } else if (path === 'M') {
                return '메세지';
            } else if (path === 'K') {
                return '카카오톡';
            } else if (path === 'O') {
                return '온라인';
            } else if (path === 'E') {
                return `기타 ${etc ? `(${etc})` : ''}`;
            }
        },

        // 유입경로 변환
        convertInfoPath(path) {
            if (path === 'P') {
                return '전단지';
            } else if (path === 'S') {
                return 'SNS';
            } else if (path === 'B') {
                return '블로그';
            } else if (path === 'H') {
                return '홈페이지';
            } else if (path === 'I') {
                return '지인소개';
            }
        },

        // 상담 목록 키워드 검색 이벤트
        onEventSearch(e) {
            if (this.searchStr.length > 0 && this.searchStr.length < 2) {
                return;
            }
            this.fetchConsultList();
        },

        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            console.log(val);
            this.consultPagingInfo.limit = val;
            this.fetchConsultList();
        },

        // 페이지 변경 Handler
        handlerPagenation(event, pagingType) {
            if (pagingType === 'customer') {
                this.customerPagingInfo.page = event;
                this.onSearchCustomer();
            } else if (pagingType === 'consult') {
                this.consultPagingInfo.page = event;
                this.fetchConsultList();
            }
        },

        // 상담 내용 상세보기 버튼 클릭시
        async onClickModifyConsult(centerId, consultId) {
            this.advicePop = true;
            try {
                this.detailConsultId = consultId;
                this.detailConsultLoading = true;
                const { data } = await this.fetchConsultDetail(centerId, consultId);
                this.consultDetailInfo = data;
                const { consultDetailInfo, detailEditField } = this;
                detailEditField.customerNme = consultDetailInfo.customerNme;
                detailEditField.centerStaffId = consultDetailInfo.centerStaffId;
                detailEditField.consultedAt = consultDetailInfo.consultedAt;
                detailEditField.consultTypeId = consultDetailInfo.consultTypeId;
                detailEditField.consultTypeName = consultDetailInfo.consultTypeName;
                detailEditField.consultPath = consultDetailInfo.consultPath;
                detailEditField.consultPathEtc = consultDetailInfo.consultPathEtc;
                detailEditField.centerConsultFunnelId = consultDetailInfo.centerConsultFunnelId;
                detailEditField.memo = consultDetailInfo.memo;
                this.detailConsultLoading = false;
            } catch (error) {
                alert('상담 내용을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터 상담 관리 조회
        fetchConsultDetail(centerId, consultId) {
            return api.get(`/admin/api/center/${centerId}/consult/${consultId}`);
        },

        // 상담 내용 삭제 버튼 클릭시
        async onClickDeleteConsult(centerId, consultId) {
            try {
                if (!confirm('상담을 삭제하시겠습니까?')) {
                    return false;
                }
                this.isLoading = true;
                await this.sendDeleteConsult(centerId, consultId);
                alert('상담을 삭제했습니다.');
                await this.fetchConsultList();
                this.isLoading = false;
            } catch (error) {
                alert('상담 삭제 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 상담 삭제 API 호출
        sendDeleteConsult(centerId, consultId) {
            return api.delete(`/admin/api/center/${centerId}/consult/delete/${consultId}`);
        },

        // 상담 내용 팝업 수정 버튼 클릭시
        async onClickSaveConsultDetail() {
            try {
                this.detailConsultLoading = true;
                const { data } = await this.sendPutConsultDetail();
                alert('상담 내용이 수정 되었습니다.');
                this.detailConsultLoading = false;
                this.advicePop = false;
                this.fetchConsultList();
            } catch (error) {
                alert('상담 내용 수정 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터상담관리 수정 API 호출
        sendPutConsultDetail() {
            return api.put(`/admin/api/center/${this.centerId}/consult/${this.detailConsultId}`, {
                ...this.detailEditField,
            });
        },

        // 상담 내용 팝업 취소 버튼 클릭시
        onClickCancleConsultDetail() {
            this.advicePop = false;
        },

        // 연락처 split
        splitPhoneNumber(phoneNumber) {
            console.log(phoneNumber);

            if (!phoneNumber) return phoneNumber;

            phoneNumber = phoneNumber.replace(/[^0-9]/g, '');

            const tmp = ['', '', ''];
            if (phoneNumber.length < 4) {
                return phoneNumber;
            } else if (phoneNumber.length < 7) {
                tmp[0] = phoneNumber.substr(0, 3);
                tmp[1] = phoneNumber.substr(3);
            } else if (phoneNumber.length == 8) {
                tmp[0] = phoneNumber.substr(0, 4);
                tmp[1] = phoneNumber.substr(4);
            } else if (phoneNumber.length < 10) {
                if (phoneNumber.substr(0, 2) == '02') {
                    // 02-123-5678
                    tmp[0] = phoneNumber.substr(0, 2);
                    tmp[1] = phoneNumber.substr(2, 3);
                    tmp[2] = phoneNumber.substr(5);
                }
            } else if (phoneNumber.length < 11) {
                if (phoneNumber.substr(0, 2) == '02') {
                    // 02-1234-5678
                    tmp[0] = phoneNumber.substr(0, 2);
                    tmp[1] = phoneNumber.substr(2, 4);
                    tmp[2] = phoneNumber.substr(6);
                } else {
                    // 010-123-4567
                    tmp[0] = phoneNumber.substr(0, 3);
                    tmp[1] = phoneNumber.substr(3, 3);
                    tmp[2] = phoneNumber.substr(6);
                }
            } else {
                // 010-1234-5678
                tmp[0] = phoneNumber.substr(0, 3);
                tmp[1] = phoneNumber.substr(3, 4);
                tmp[2] = phoneNumber.substr(7);
            }
            return tmp;
        },
    },
};
</script>
<style lang="scss"></style>
